import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { getErrorDetailsText } from '@shared/error';
import { ErrorModal } from '@shared/ui';
import { usePaymentFlowErrorModal } from '../../lib/usePaymentFlowErrorModal';
import type { UsePaymentFlowErrorModalParams } from '../../lib/types';

type Props = UsePaymentFlowErrorModalParams;

const PaymentFlowErrorModal: FC<Props> = props => {
	const { t } = useTranslation('PaymentResult');
	const modalState = usePaymentFlowErrorModal(props);

	if (!modalState) {
		return null;
	}

	const { error, onConfirm, onClose, onCancel } = modalState;

	return (
		<ErrorModal
			header={t('PaymentResultFlow.Error.Header')}
			title={error.title ?? t('PaymentResultFlow.Error.Title')}
			message={error.message ?? t('PaymentResultFlow.Error.Message')}
			detailsTitle={t('PaymentResultFlow.Error.DetailsTitle')}
			detailsDescription={t('PaymentResultFlow.Error.DetailsDescription')}
			isOpen
			details={error.details}
			detailsText={getErrorDetailsText(error.details)}
			confirmBtn={t('PaymentResultFlow.Error.ConfirmButton')}
			cancelBtn={t('PaymentResultFlow.Error.CancelButton')}
			onClose={onClose}
			onConfirm={onConfirm}
			onCancel={onCancel}
		/>
	);
};

export default PaymentFlowErrorModal;
